import { Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Categories from "@/pages/Categories";
import ToolDetail from "@/pages/ToolDetail";
import Profile from "@/pages/Profile";
import SearchResults from "@/pages/SearchResults";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import About from "@/pages/About";
import { createContext, useState } from "react";

export const AuthContext = createContext({
  isAuthenticated: false,
  setIsAuthenticated: (value: boolean) => {},
  logout: () => {},
});

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const logout = () => {
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, setIsAuthenticated, logout }}
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/category/:id" element={<Categories />} />
        <Route path="/tools/:id" element={<ToolDetail />} />
        <Route path="/tool/:id" element={<ToolDetail />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </AuthContext.Provider>
  );
}
